import { KrybotService } from '../../services/api/krybotService';
import type { ChatPanelAttachmentRecord } from './chatPanelAttachments';

export interface ExtractionRoutingMetadata {
  message_kind?: string;
  extraction_status?: string;
  attachment_id?: string;
  artifact_item_ref?: string;
}

export function readExtractionRoutingMetadata(
  metadata: Record<string, unknown> | undefined
): ExtractionRoutingMetadata | null {
  if (!metadata || metadata.message_kind !== 'extraction_routing') {
    return null;
  }
  return {
    message_kind: String(metadata.message_kind),
    extraction_status:
      typeof metadata.extraction_status === 'string' ? metadata.extraction_status : undefined,
    attachment_id: typeof metadata.attachment_id === 'string' ? metadata.attachment_id : undefined,
    artifact_item_ref:
      typeof metadata.artifact_item_ref === 'string' ? metadata.artifact_item_ref : undefined,
  };
}

export async function routeChatAttachmentExtractions(
  threadId: string,
  attachments: ChatPanelAttachmentRecord[],
  options: { userId: string; artifactItemRef?: string }
): Promise<void> {
  for (const attachment of attachments) {
    await KrybotService.routeAttachmentExtraction(threadId, attachment.id, {
      userId: options.userId,
      artifactItemRef: attachment.artifactItemRef ?? options.artifactItemRef,
    });
  }
}
